import { PriceRequest } from '../types/pricing.types';
import { PriceRequestFilters } from './price-request.state';

export const PRICE_REQUEST_NAME = 'PriceRequest';

export class LoadPriceRequestsListAction {
  static type = `[${PRICE_REQUEST_NAME} LoadPriceRequestsListAction]`;

  constructor(
    public filters: PriceRequestFilters,
    public pageToLoad = 1
  ) {}
}

export class ApprovePriceRequestsAction {
  static type = `[${PRICE_REQUEST_NAME} ApprovePriceRequestsAction]`;

  constructor(public ids: string[]) {}
}

export class DeletePriceRequestAction {
  static type = `[${PRICE_REQUEST_NAME} DeletePriceRequestAction]`;

  constructor(public priceRequest: PriceRequest) {}
}
